import { render, staticRenderFns } from "./PhotosModals.vue?vue&type=template&id=c2ae5a40&"
import script from "./PhotosModals.vue?vue&type=script&lang=js&"
export * from "./PhotosModals.vue?vue&type=script&lang=js&"
import style0 from "./PhotosModals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports